interface InviteToastsProps {
  copied: boolean
  copyError: boolean
  shareErrorType?: 'permission_denied' | 'not_supported' | 'generic' | null
}

export function InviteToasts({
  copied,
  copyError,
  shareErrorType,
}: InviteToastsProps) {
  return (
    <>
      {copied && (
        <div
          className='fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-black/80 px-[20px] py-[12px] text-white'
          data-testid='copy-success-toast'
        >
          Link copied!
        </div>
      )}

      {copyError && (
        <div
          className='fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-red-600 px-[20px] py-[12px] text-white'
          data-testid='copy-error-toast'
        >
          Failed to copy link
        </div>
      )}

      {shareErrorType === 'permission_denied' && (
        <div
          className='fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-orange-600 px-[20px] py-[12px] text-center text-white'
          data-testid='share-permission-denied-toast'
        >
          Share permission denied. Please use Copy Link instead.
        </div>
      )}

      {shareErrorType === 'not_supported' && (
        <div
          className='fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-orange-600 px-[20px] py-[12px] text-center text-white'
          data-testid='share-not-supported-toast'
        >
          Share not supported. Please use Copy Link instead.
        </div>
      )}

      {shareErrorType === 'generic' && (
        <div
          className='fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-red-600 px-[20px] py-[12px] text-center text-white'
          data-testid='share-error-toast'
        >
          Failed to share. Please try Copy Link instead.
        </div>
      )}
    </>
  )
}
